<!--厦门国际银行理财体验官-升金有礼-规则-行方app打开 -->
<template>
  <div class="xiame-bank-ascend-gold-rule">
    <MyHeader />
    <div class="title">活动细则</div>
    <img
      class="img1"
      :src="require(`@/assets/imgs/xiameBankDepositStandard/rule1.png`)"
      alt=""
    />
    <div class="content">
      <ul class="list">
        <li v-for="item in data" :key="item.id">
          <div class="header">
            <img class="icon" :src="item.img" alt="" />
            <span class="name">{{ item.name }}</span>
          </div>
          <p class="des" v-html="item.text"></p>
        </li>
      </ul>
    </div>
    <img
      class="img2"
      :src="require(`@/assets/imgs/xiameBankDepositStandard/rule3.png`)"
      alt=""
    />
  </div>
</template>
<script>
import MyHeader from './components/MyHeader.vue'
export default {
  components: { MyHeader },
  data() {
    return {
      title: '厦门国际银行',
      data: [
        {
          img: require(`@/assets/imgs/xiameBankDepositStandard/icon_1.png`),
          name: '活动报名时间',
          text: `即日起至2025年10月31日`
        },
        {
          img: require(`@/assets/imgs/xiameBankDepositStandard/icon_1.png`),
          name: '奖励领取时间',
          text: `2025年11月4日至2025年11月30日`
        },
        {
          img: require(`@/assets/imgs/xiameBankDepositStandard/icon_2.png`),
          name: '活动对象',
          text: `厦门国际银行借记卡持卡客户`
        },
        {
          img: require(`@/assets/imgs/xiameBankDepositStandard/icon_2.png`),
          name: '活动报名及领取奖励路径',
          text: `厦门国际银行APP—活动中心—财富晋升回馈。`
        },
        {
          img: require(`@/assets/imgs/xiameBankDepositStandard/icon_3.png`),
          name: '活动规则',
          text: `1、客户需开通厦门国际银行手机银行。
2、客户在活动报名时间内进入活动页面进行报名后，2025年10月综合贡献值较2025年9月提升达相应档位，即可领取对应奖励。各档位奖品不可重复获取，数量有限，先到先得。
具体档位及奖励设置如下：
(1)第一档：10元微信立减金券包，共2200份；
(2)第二档：20元微信立减金券包，共800份；
(3)第三档：50元微信立减金券包，共800份；
(4)第四档：150元微信立减金券包，共200份；
(5)第五档：200元微信立减金券包，共90份；
(6)第六档：400元微信立减金券包，共40份。`
          //  1、客户需开通厦门国际银行手机银行。
          // 2、客户在活动报名时间内进入活动页面进行报名后，2025年5月综合贡献值较2025年4月提升达相应档位，即可领取对应奖励。各档位奖品不可重复获取，数量有限，先到先得。具体档位及奖励设置如下：
          // （1）第一档：15元微信立减金券包，包括5元微信立减金3张；
          // （2）第二档：25元微信立减金券包，包括10元微信立减金1张，5元微信立减金3张；
          // （3）第三档：60元微信立减金券包，包括20元微信立减金1张、10元微信立减金2张，5元微信立减金4张；
          // （4）第四档：100元微信立减金券包，包括20元微信立减金3张、10元微信立减金2张、5元微信立减金4张。


        },
        {
          img: require(`@/assets/imgs/xiameBankDepositStandard/icon_3.png`),
          name: '立减金使用规则',
          text: `1.微信立减金自领取日起30日有效。不支持转发他人，不找零。过期失效。逾期不补发。 
2.使用微信支付时选择厦门国际银行借记卡支付满足立减金消费门槛自动抵扣优惠。
3.使用优惠的微信支付订单，如发生全额退款，且优惠券仍在有效期内，优惠券将自动退还给用户，如优惠券已过期，则不退还；如发生部分退款，用户支付金额将按比例原路退还，优惠券将不退还给用户。 
4.微信立减金限微信支付商家使用，个人收款码、生活缴费、理财交易、转账红包等不可使用。部分商户不支持使用，包含CoCo奶茶、优衣库、星巴克、肯德基、必胜客、同程艺龙、热风、太平鸟、孩子王、华为商城、Apple商城、零钱通、理财通。详细名单以微信官方为准。
5.立减券限用一次，不可叠加使用、不兑现、不找零、不挂失且过期作废。
6.此活动不可与其他优惠券叠加使用。
7.使用过程如有问题或疑问，请联系易点生活电子商务有限公司,客服电话：<a href="tel:400-662-7299">400-662-7299</a>。
`
        },
        {
          img: require(`@/assets/imgs/xiameBankDepositStandard/icon_3.png`),
          name: '温馨提示',
          text: `1. 参与默认规则：参与活动即视为同意活动规则，提醒参与者提前仔细阅读。
2. 卡券领取与使用：奖品以卡券形式发放，在活动页面“我的卡包”查看使用，需按“卡券说明”操作，逾期未兑换至个人账户视为放弃奖品且不予补发 。
3. 免责声明：因客户操作不当或网络、运营商故障等非银行可控原因致无法参与活动，银行不负责。
4. 规则变动权：银行可依活动实际情况，在法律允许范围内变动调整活动规则，公布时即时生效。
5. 支持与客服：活动由易点生活电子商务有限公司支持。领取有问题工作日9:00 - 21:00拨打<a href="tel:400-662-7299">400-662-7299</a>；其他疑问每日8:30 - 20:00拨打厦门国际银行客服热线<a href="tel:956085">956085</a>。
`
        },


      ]
    }
  },
  created() {

  },
  methods: {
    xibSignContractLogin() {

    },

  },
}
</script>
<style lang="less">
.xiame-bank-ascend-gold-rule {
  min-height: 100vh;
  font-size: 14px;
  padding: 55px 14px 15px 14px;
  background: #feecdf;
  box-sizing: border-box;
  position: relative;
  font-size: 0;

  .title {
    position: absolute;
    top: 63px;
    left: 0;
    width: 100%;
    text-align: center;
    font-size: 19px;
    font-weight: 800;
    color: #ffffff;
    text-shadow: 1px 1px 0px rgba(222, 14, 37, 0.34);
  }

  .img1,
  .img2 {
    width: 100%;
  }

  .content {
    background: url("../../../assets/imgs/xiameBankDepositStandard/rule2.png")
      repeat-Y;
    background-size: contain;
    padding: 0px 20px 1px 20px;
    font-size: 12px;
    color: #3f3f47;
    min-height: calc(100vh - 160px);
    margin-top: -3px;
  }

  .list {
    li {
      line-height: 1.6;
    }

    .header {
      // line-height: 2;
    }
    .des {
      margin: 8px 0 15px 0;
    }

    .icon {
      margin-right: 5px;
      width: 18px;
      vertical-align: sub;
    }

    .name {
      font-size: 15px;
      font-weight: bold;
      color: #f44244;
    }

    p {
      white-space: pre-line;
      text-align: justify;
    }
    a {
      color: #3f3f47;
    }

    .red {
      color: #f44244;
    }

    strong {
      font-weight: bold;
    }
  }
}
</style>
